import {
    snapshotConfig,
    SnapshotType,
} from 'app/agriculture/queries/snapshots/config/snapshotConfig';
import { bucketConfig } from 'app/agriculture/queries/snapshots/config/bucketConfig';
import { useTimelineViewMode } from 'app/agriculture/AgTimeline/context/TimelineContext';
import { useCursorTime } from 'app/agriculture/hooks/useCursorTime/useCursorTime';
import {
    cursorTimeDebounceDelay,
    cursorTimeThrottleDelay,
} from 'app/agriculture/queries/snapshots/config/consts';
import { useDebounce } from 'use-debounce';

/** Returns cursorTime, throttled if this snapshot type should behave smoothly, and debounced if it doesn't matter */
export function useCursorTimeForSnapshotType({
    snapshotType,
    cursorTimeOverride,
}: {
    snapshotType: SnapshotType;
    cursorTimeOverride?: Date;
}) {
    const { bucketSize } = snapshotConfig[snapshotType];
    const { viewModesThatFetchAllBuckets } = bucketConfig[bucketSize];
    const { id: viewMode } = useTimelineViewMode();

    const throttledCursorTime = useCursorTime({
        override: cursorTimeOverride,
        throttleDelay: cursorTimeThrottleDelay,
    });

    const [debouncedCursorTime] = useDebounce(throttledCursorTime, cursorTimeDebounceDelay);

    return viewModesThatFetchAllBuckets.includes(viewMode)
        ? throttledCursorTime
        : debouncedCursorTime;
}
